import { isValidInviteEmail, isValidInvitePhone } from "../components/invite_clients/parseInviteClientImport"

const FIRST_NAME_KEYS = ["first_name", "firstName", "First Name", "First name", "firstname"]
const LAST_NAME_KEYS = ["last_name", "lastName", "Last Name", "Last name", "lastname"]
const EMAIL_KEYS = ["email", "Email", "EMAIL", "E-mail", "E-mail Address"]
const PHONE_KEYS = ["phone", "Phone", "Phone number", "Phone Number", "mobile", "Mobile"]
const NOTES_KEYS = ["notes", "Notes", "note", "Note"]

function pickString(obj: Record<string, unknown>, keys: string[]): string {
  for (const k of keys) {
    const v = obj[k]
    if (v == null) continue
    const s = String(v).trim()
    if (s) return s
  }
  return ""
}

/** CSVBox row keys follow mapped template names or raw spreadsheet headers. */
export function normalizeCsvBoxClientRow(raw: Record<string, unknown>): {
  email: string
  firstName: string
  lastName: string
  phone: string
  notes: string
} {
  const unmapped = (raw._unmapped_data as Record<string, unknown>) || {}
  const pick = (keys: string[]) => pickString(raw, keys) || pickString(unmapped, keys)

  return {
    email: pick(EMAIL_KEYS),
    firstName: pick(FIRST_NAME_KEYS),
    lastName: pick(LAST_NAME_KEYS),
    phone: pick(PHONE_KEYS),
    notes: pick(NOTES_KEYS)
  }
}

export function hasInviteEmailOrPhone(email: string, phone: string): boolean {
  return isValidInviteEmail(email) || isValidInvitePhone(phone)
}

export function dedupeCsvBoxRowsByEmail(rows: Record<string, unknown>[]): Record<string, unknown>[] {
  const map = new Map<string, Record<string, unknown>>()
  let noEmailIdx = 0
  for (const row of rows) {
    const { email, phone } = normalizeCsvBoxClientRow(row)
    const emailKey = email.trim().toLowerCase()
    const phoneKey = phone.replace(/\D/g, "")
    // Dedupe only by email. Phone-only / no-contact rows keep unique keys so
    // shared phones (e.g. family) are not collapsed — matches pre-OR behavior.
    const key = emailKey || (phoneKey ? `__phone_${phoneKey}_${noEmailIdx++}` : `__no_contact_${noEmailIdx++}`)
    map.set(key, row)
  }
  return Array.from(map.values())
}

/**
 * CSVBox `row_success` is the row count before we collapse duplicate emails.
 * Compare it to the raw callback length. A gap after dedupe is repeated emails, not a dropped chunk.
 */
export function csvBoxImportLooksIncomplete(arrivedCount: number, reportedRowSuccess: number): boolean {
  const reportedTotal = reportedRowSuccess > 0 ? reportedRowSuccess : arrivedCount
  const shortfall = reportedTotal - arrivedCount
  const tolerance = Math.max(10, Math.floor(reportedTotal * 0.05))
  return shortfall > tolerance
}

export { isValidInviteEmail, isValidInvitePhone }
